module.exports = __webpack_public_path__ + "static/media/gh-neighbourhood-map.6bb77897.png";